( function( $, document ) {
    'use strict';

    $( document ).ready( function() {
    	/**
     * Call magnificPopup when use
     */
   
        // WordPress gallery lightbox
        jQuery('.gallery-lightbox').each(function () {
            jQuery(this).magnificPopup({
                delegate: '.gallery-item a',
                type:'image',
                gallery:{
                    enabled: true
                },
                zoom: {
                    enabled: true
                }
            });
        });
    } );

} )( jQuery, document );
